(app => {

    app.component("accountNotesBtn",
        {
            template: `
                <md-button class="md-icon-button btn-accent" ng-click="$ctrl.openNotes({ $event: $event })">
                    <md-icon md-font-icon="mdi mdi-24px mdi-message-bulleted" aria-label="View Notes"></md-icon>
                    <md-tooltip md-delay="500">View Account Notes</md-tooltip>
                </md-button>
            `,
            bindings: {
                openNotes: "&"
            }
        });

})(window.app);